/* eslint import/prefer-default-export: */
export { default as reducer } from './reducer';
